/**
 * The contents of a file as base64, which is how a body of JSON has the bytes of a file
 * @param file The file that the user chose
 * @returns The base64 of its bytes, with nothing before it
 */
export const fileToBase64 = (file: File): Promise<string> => {

    return new Promise<string>((resolve, reject) => {

        const reader = new FileReader();

        reader.onload = () => {
            // the result is a data URL: "data:<type>;base64,<the bytes>"
            const result = String(reader.result ?? '');
            resolve(result.substring(result.indexOf(',') + 1));
        };

        reader.onerror = () => reject(reader.error ?? new Error('The file could not be read.'));
        reader.readAsDataURL(file);
    });
};
